// extracted by mini-css-extract-plugin
export default {"container":"lq-z","ratingLayout":"mq-z","ratingLabel":"nq-z","nonInteractiveRatingLabel":"oq-z"};